export function BrandMark({ size = 32, opacity = 1 }: { size?: number; opacity?: number }): JSX.Element {
  const fill = '#0A0A0A';
  return (
    <svg width={size} height={size} viewBox="0 0 80 80" aria-hidden="true">
      <circle cx="16" cy="22" r="14" fill={fill} opacity={opacity} />
      <circle cx="16" cy="58" r="14" fill={fill} opacity={opacity} />
      <rect x="9" y="22" width="14" height="36" fill={fill} opacity={opacity} />
      <circle cx="46" cy="22" r="11" fill={fill} opacity={opacity} />
      <path d="M 61 11 a 11 11 0 0 1 0 22 Z" fill={fill} opacity={opacity} />
      <circle cx="46" cy="58" r="11" fill={fill} opacity={opacity} />
      <path d="M 61 47 a 11 11 0 0 1 0 22 Z" fill={fill} opacity={opacity} />
    </svg>
  );
}

export function BrandLockup(): JSX.Element {
  return (
    <div className="brand-row">
      <BrandMark size={32} />
      <div>
        <div className="brand-name">AI Software Factory</div>
        <div className="brand-tagline">A&nbsp;COGNESENSE&nbsp;BRAND&nbsp;·</div>
      </div>
    </div>
  );
}
